import { getSongsLibrary, updateSong as updateSongAPI, deleteSong as deleteSongAPI } from "../../../helpers/song_helper";
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSongs = createAsyncThunk(
  'songs/fetchSongs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSongsLibrary();
      console.log('API Response:', response);
      // API Platform returns collection in 'hydra:member' or directly as array
      return response['hydra:member'] || response;
    } catch (error) {
      console.error('Fetch songs error:', error);
      return rejectWithValue(error || 'Failed to fetch songs');
    }
  }
);

export const updateSong = createAsyncThunk(
  'songs/updateSong',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateSongAPI(id, data);
      return response;
    } catch (error) {
      console.error('Update song error:', error);
      return rejectWithValue(error || 'Failed to update song');
    }
  }
);

export const deleteSong = createAsyncThunk(
  'songs/deleteSong',
  async (id, { rejectWithValue }) => {
    try {
      await deleteSongAPI(id);
      return id;
    } catch (error) {
      console.error('Delete song error:', error);
      return rejectWithValue(error || 'Failed to delete song');
    }
  }
);
